import { DashboardCanvasProvider, DashboardContent, DashboardHeader } from '@factorialco/f0-react'
import type { DashboardCanvasContent } from '@factorialco/f0-react'

import { defineCanvasEntity } from 'modules/ai/copilotActions/canvas/defineCanvasEntity'

/**
 * Canvas renderer for `{ type: "dashboard" }` content. Wraps the body in
 * `DashboardCanvasProvider` so the header (save/edit) and content (compute
 * + grid) share state. Dashboard manages its own scroll: the grid grows with
 * `flex-1` so a single-item dashboard fills the height (no scroll), while a
 * multi-item dashboard scrolls internally above the persistent action bar.
 */
export const dashboardCanvasEntity = defineCanvasEntity<DashboardCanvasContent>({
  type: 'dashboard',
  renderContent: ({ content, refreshKey }) => (
    <DashboardContent content={content} refreshKey={refreshKey} />
  ),
  renderHeader: ({ content, onClose }) => <DashboardHeader content={content} onClose={onClose} />,
  wrapper: ({ content, children }) => (
    <DashboardCanvasProvider content={content}>{children}</DashboardCanvasProvider>
  ),
  overflowHidden: true,
})
